import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowLeft02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { useCheckUserRole, useIsMyOnlyRole } from "hooks/useCheckUserRole";
import Role from "enums/Role";

/**
 * "Back to admin" for the shells that are not admin, landing where
 * `resolveLandingRoute` would. A /my-only role has no admin area to go back to.
 */
const BackToAdminAction: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isMyOnly = useIsMyOnlyRole();
  const isAuditorOrAbove = useCheckUserRole(Role.Auditor);

  if (isMyOnly) return null;

  return (
    <Button
      variant="default-outlined"
      startIcon={<HugeiconsIcon icon={ArrowLeft02Icon} size={20} />}
      onClick={() =>
        navigate(isAuditorOrAbove ? "/admin/dashboard" : "/admin/transactions")
      }
      // Collapsed so the label and the icon share vertical metrics.
      sx={{ lineHeight: 1 }}
    >
      {t("Back to admin")}
    </Button>
  );
};

export default BackToAdminAction;
